<template>
  <div
    class="video-module"
    :style="{
      height: `${data.style.height}px`,
      borderRadius: `${data.style.radius}px`,
    }"
  >
    <video
      v-if="videoSource"
      class="video-player"
      :src="videoSource"
      :poster="videoCover"
      :autoplay="data.params.autoplay"
      :loop="data.params.loop"
      :muted="data.params.muted"
      :controls="data.params.controls"
      playsinline
      webkit-playsinline
      preload="metadata"
    ></video>
    <div v-else class="video-placeholder">
      <VideoCameraOutlined class="video-icon" />
      <!-- <span>请在右侧选择视频素材</span> -->
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { VideoCameraOutlined } from "@ant-design/icons-vue";
import store from "@/store";

export default {
  name: "VideoModule",
  components: { VideoCameraOutlined },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const picdomain = store.state.user.info.picdomain;
    const getResourceUrl = (url) => {
      if (!url) return "";
      if (url.indexOf("http") === 0 || url.indexOf("//") === 0 || url.indexOf("data:") === 0 || url.indexOf("blob:") === 0) {
        return url;
      }
      return picdomain + url;
    };
    const videoSource = computed(() => getResourceUrl(props.data.params.video_source));
    const videoCover = computed(() => getResourceUrl(props.data.params.video_cover));

    return {
      videoSource,
      videoCover,
    };
  },
};
</script>

<style lang="less" scoped>
.video-module {
  width: 100%;
  overflow: hidden;
  background: #eef2f5;
}

.video-player {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #8c8c8c;
  background: #f5f7fa;
  border: 1px dashed #c8d0d9;
  box-sizing: border-box;
}

.video-icon {
  font-size: 32px;
  color: #05486a;
}
</style>
